import api from "@/config/axiosConfig";
import { AxiosResponse } from "axios";

interface AirlineResult {
  name: string;
  code: string;
  image: string;
}

export interface AirportResult {
  data: {
    code: string;
    name: string;
    coordinates: {
      latitude: number;
      longitude: number;
    };
    timezone: string;
  }[];
  success: boolean;
}

class TransportService {
  async airlineSearch(query: string): Promise<AxiosResponse<AirlineResult[]>> {
    return await api.content.get("/airline", {
      params: {
        q: query,
      },
    });
  }

  async airportSearch(query: string): Promise<AxiosResponse<AirportResult>> {
    return await api.transport.get("/airports/search", {
      params: {
        q: query,
      },
    });
  }
}

export const transportService = new TransportService();
export default transportService;
